import {
  getMeetingPlanByCategory,
  getTitleNameI18nKey,
  isAutoAddable,
  isZoneBundleContext,
  ZOOM_MEETING_SUB_TYPES,
  isEduUpgradeContext, isBizPlusEditContext
} from '@/plans/ZOOM_MEETING/common/utils';
import { plansof } from '@/utils/chain';
import {
  BASE_PLAN_SUB_TYPES,
  BILLING_CYCLE,
  BIZ_PLUS_PLAN_CODES_ONLINE_SUPPORTED,
  PBX_CATEGORYS,
  planTypes,
  PRO_PLUS_PLAN_CODES_SUPPORTED,
  ZOOM_MEETING_PRO_MIN_LICENSE,
  trackingPlanTypes,
  ZOOM_ONE_PRO_PLUS_MAX_LICENSE,
  INDUSTRIES,
  autoAddTypes,
  EDU_SCH_CMP_PLUS_PLAN_CODES_SUPPORTED,
  ZOOM_MEETING_EDU_SCH_CMP_MIN_LICENSE,
  ZOOM_MEETING_EDU_PLUS_MIN_LICENSE,
  DEFAULT_MAX_HOST,
  DEFAULT_MIN_HOST
} from '@/common/constants';
import { generateCartIdWithQueryKey } from '@/views/config/shopping-cart/share-link.vue';
import { getPlanTypeByCategory } from '@/common/service/parse';
import { $query } from '@/global-install';
import { phoneNumberStorage } from '@/plans/ZOOM_PHONE/store';
import { zoneBundleUtils, getAssignedLicenseQuantity } from '@/plans/ZOOM_ONE_BUNDLE/utils';
import { ONLINE_NOT_SUPPORT_BILLING_CYCLE } from '@/common/service/non-standard-billing-cycle-utils';
import { computedPbxPlans, computedPbxBasePlans, computedPbxNonBasePlans } from '@/common/service/computers/plans/pbx';
import { getMigrateFlowType, MIGRATE_FLOW_TYPES, migrationPlanTypes } from '@/plans/ZOOM_MEETING/dialog/migration-plan';
import { get, groupBy } from 'lodash';
import { mapActions, mapGetters ,mapMutations } from 'vuex';
import { getPbxCurrentBillingCycle } from '@/plans/ZOOM_PHONE/helper/pbx-billing-cycle';
import { updateHrefWithQueryParams } from '@/utils';
import { PARTNER_REFER_KEY_MAP } from '@/views/config/partner-refer/helper/constant';
import { translateToEn } from '@/plugins/i18n'
import { getSelfTotalLicenseAmount, getMinimumSubjectLicense } from '@/plans/ZONE_EDU_PLUS/utils';
import { getPersistCouponQueryInfo } from '@/views/config/coupon/helper/utils';

const URL_PAGE_TYPE_KEY = "pageType";

const hostCache = {};
/**
 * @enum {string}
 */
const StoreActionTypes = {
  REMOVE: 'remove',
  UPDATE: 'update',
};

export default {
  data() {
    return {
      storeActionQueue: [],
    };
  },
  computed: {
    ...mapGetters([
      'boughtPlans',
      'currentEditPlan',
      'getSelectedPlans',
      'healthcareAvailable',
      'getCurrentBasePlanInfo',
      'getUserCurrentSubscriptions',
    ]),
    pbxBasePlan() {
      return computedPbxBasePlans(this.boughtPlans)?.[0];
    },
    selectedPlansFromTypeGroup() {
      const orders = [
        { planType: planTypes.ZOOM_MEETING, index: 1,},
        { planType: planTypes.ZOOM_ONE_BUNDLE, index: isBizPlusEditContext ? 0 : 2,},
        { planType: planTypes.ZONE_EDU_PLUS, index: 3,},
        { planType: planTypes.ZONE_PRO_PLUS, index: 4,},
      ];
      return orders.sort((a,b) => a.index - b.index)
          .map(({planType}) => { return (this.getTypeGroupSelectedPlans?.[planType])?.[0]; })
          .filter(item => item)?.[0] ?? {};
    },
    currentBaseCycle() {
      const plan = this.getCurrentBasePlanInfo.plans[0];
      if (plan) return plan.billing_cycle;
      return null;
    },
    currentPbxCycle() {
      const plan = computedPbxNonBasePlans(this.getUserCurrentSubscriptions)[0]
      if (plan) return plan.billing_cycle;
      return null;
    },
  },
  methods: {
    ...mapMutations(['setSelectedPlanLicense']),
    ...mapActions(['removePlanByKey']),
    handlerSwitchPlan(col = {}) {
      switch(col.category) {
        case ZOOM_MEETING_SUB_TYPES.PRO:
        case ZOOM_MEETING_SUB_TYPES.BIZ:
          return this.switchMeetingPlanCategory(col);
        case ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_BIZ_PLUS:
        case ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_PRO_PLUS:
        case ZOOM_MEETING_SUB_TYPES.ZONE_EDU_PLUS:
        default:
          return this.jumpToOldFlow(col);
      }
    },
    // col -> next click button
    async handleSwitchMeetingPlan(col) {
      if (col?.btn?.disabled) return;

      if (this.healthcareAvailable) {
        const trackingPlanName = translateToEn(getTitleNameI18nKey(this.currentBaseCategory))
        const trackingModalName = `${translateToEn('billing.healthcare.switch_plan_confirm.title')} modal`
        this.$tracking.buyInteraction(
          'product details',
          `${trackingPlanName} ${INDUSTRIES.HEALTHCARE} - ${trackingModalName} - impression`,
        )

        const h = this.$createElement
        const onMessageClick = (event) => {
          if (event.target instanceof HTMLAnchorElement) {
            this.$tracking.buyInteraction(
              'product details',
              `${trackingPlanName} ${INDUSTRIES.HEALTHCARE} - ${trackingModalName} - contact sales`,
            )
          }
        }

        try {
          await this.$confirm(
            h('div', {
              domProps: { innerHTML: this.$t('billing.healthcare.switch_plan_confirm.desc') },
              on: { click: onMessageClick },
            }),
            this.$t('billing.healthcare.switch_plan_confirm.title'),
            {
              customClass: 'opc-meeting-switch-plan-for-healthcare-confirm',
              confirmButtonText: this.$t('common.btn_continue'),
              cancelButtonText: this.$t('billing.common.cancel'),
              roundButton: true,
            },
          )
          this.$tracking.buyInteraction(
            'product details',
            `${trackingPlanName} ${INDUSTRIES.HEALTHCARE} - ${trackingModalName} - continue`,
          )
        } catch (err) {
          this.$tracking.buyInteraction(
            'product details',
            `${trackingPlanName} ${INDUSTRIES.HEALTHCARE} - ${trackingModalName} - cancel`,
          )
          return
        }
      }

      // current edit plan
      if (this.$context.is.edit) {
        const currentEditPlan = this.selectedPlansFromTypeGroup;
        const originalEditPlan = this.currentEditPlan;
        const currentEditPlanCategory = currentEditPlan.zoomMeetingCategory;
        const originEditPlanCategory = originalEditPlan.zoomMeetingCategory;
        const nextEditPlanCategory = col.category;
        const migrateType = migrationPlanTypes({
          originEditPlanCategory,
          currentEditPlanCategory,
          nextEditPlanCategory,
        });
        const action = this.getFnByMigrateTypes();
        console.log(`[migration-plan] =>`, migrateType);
        if (migrateType && action[migrateType]) {
          console.log(`[migration-plan: time 1] => ${Date.now()}`);
          await this.beforeMigration({ currentEditPlanCategory, originEditPlanCategory });
          console.log(`[migration-plan: time 2] => ${Date.now()}`);
          await action[migrateType].call(this, {
            col,
            currentEditPlanCategory,
            migrateType,
            originEditPlanCategory,
            nextEditPlanCategory,
          });
          this.setMigratePlanState({
            migrateType,
            flow: getMigrateFlowType(migrateType)
          });
          console.log(`[migration-plan: time 3] => ${Date.now()}`);
        }
        console.log(`[migration-plan cache] =>`, {...this.migratePlanState.hotCache}, { ...hostCache });
        // Google Analytics
        if (this.migratePlanState.is.upgrade || this.migratePlanState.is.downgrade) {
          const {trackingName, productName} = this.getGATrackingName({originEditPlanCategory, nextEditPlanCategory});
          this.$tracking.buyInteraction(`product details`, `${trackingName} full plan comparison select - ${productName}`);
        }
        if(isEduUpgradeContext){
          location.replace(updateHrefWithQueryParams(col.btn.link, [URL_PAGE_TYPE_KEY]));
        }
        this.handleSure();
        return Promise.reject();
      }

      if (this.$context.is.add2cart) {
        if (isZoneBundleContext
          || [BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS, BASE_PLAN_SUB_TYPES.ZOOM_ONE_PRO_PLUS, BASE_PLAN_SUB_TYPES.ZONE_EDU_PLUS
          ].includes(col.category)) {
          location.replace(updateHrefWithQueryParams(col.btn.link, [generateCartIdWithQueryKey, URL_PAGE_TYPE_KEY]));
          return;
        }
      }

      // !!! just for buyNow
      await this.switchProBizUrl(col);

      let trackingPlanName = ''
      if (this.healthcareAvailable) {
        trackingPlanName = `${translateToEn(getTitleNameI18nKey(col?.category))} ${INDUSTRIES.HEALTHCARE}`
      }
      this.$tracking.buyInteraction('product details', `${trackingPlanName ? `${trackingPlanName} `: ''}full plan comparison select - ${col?.category}`);

      return this.handlerSwitchPlan(col);
    },
    async beforeMigration({ currentEditPlanCategory, originEditPlanCategory }) {
      const hotCache = this.migratePlanState.hotCache;
      const isInitial = Object.keys(hotCache).length === 0 && currentEditPlanCategory !== originEditPlanCategory;
      hotCache[currentEditPlanCategory] = this.getSelectedPlans.map((p) => ({
        plan_code: p.plan_code,
        type: p.type,
        cartInfo: { ...p.cartInfo },
      }));
      if (!isInitial) {
        this.travelsalRemovePlans(this.getSelectedPlans.map(p => p.plan_code));
        const oldHotCache = hotCache?.[originEditPlanCategory];
        if (oldHotCache?.length) {
          this.traversalUpdateSelectedPlans(oldHotCache);
        }
      }
      this.setMigratePlanState({
        hotCache,
      });
    },
    async loadOriginalHotCache({ nextEditPlanCategory }) {
      if (!this.migratePlanState.flow) return;
      const oldHotCache = this.migratePlanState.hotCache?.[nextEditPlanCategory];
      this.travelsalRemovePlans(this.getSelectedPlans.map(p => p.plan_code));
      if (oldHotCache?.length) {
        this.traversalUpdateSelectedPlans(oldHotCache);
      }
    },
    switchProBizUrl(col) {
      if (isZoneBundleContext) {
        const billingCycle = plansof(this.getSelectedPlans).type(this.getCurrentBasePlanInfo.planType).get(0)?.billing_cycle || BILLING_CYCLE.ANNUAL;
        const currentPlanType = getPlanTypeByCategory($query.from);
        const curZoneBundleType = [planTypes.ZOOM_ONE_BUNDLE, planTypes.ZONE_PRO_PLUS, planTypes.ZONE_EDU_PLUS].find((p) => p === currentPlanType);
        const nextPlanCategory = col.category;
        let plan = col.category;

        let from = curZoneBundleType ? "" : $query.from;

        if (curZoneBundleType) {
          const hasZoneProPlus = plansof(this.getSelectedPlans).type(planTypes.ZONE_PRO_PLUS).has();

          // when the customer current visit zoom one pro plus, then switch should remove phone number store
          hasZoneProPlus && phoneNumberStorage.remove();

          if (nextPlanCategory === ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_PRO_PLUS) {
            plan = ZOOM_MEETING_SUB_TYPES.PRO_PLUS;
            from = zoneBundleUtils.PRO_PLUS_CATEGORY;
          }

          if (nextPlanCategory === ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_BIZ_PLUS) {
            from = zoneBundleUtils.BIZ_PLUS_CATEGORY;
          }
        }

        const baseHref=`/opc/buy/config?plan=${plan}&period=${billingCycle}&from=${from}`
        location.href = updateHrefWithQueryParams(baseHref, ['type', generateCartIdWithQueryKey, PARTNER_REFER_KEY_MAP.jointsaleCodeKey, PARTNER_REFER_KEY_MAP.referralCodeKey, 'referrer', 'source', URL_PAGE_TYPE_KEY], {
          ...getPersistCouponQueryInfo()
        });
        return Promise.reject();
      }
      return Promise.resolve();
    },
    async bundle2biz({ nextEditPlanCategory }) {
      // downgrade message
      const {
        selectedBizPlusPlan,
        boughtBizPlusPlan,
        selectedPbxBasePlan,
        totalLicenseWithoutFreeTrial,
        maxLicensesAddonPlan,
        assignedBizPlusLicenseQuantity,
      } = this.plansofBizBundle;
      const maxAddonLicense = maxLicensesAddonPlan?.cartInfo?.selected_number ?? 0;
      const quantity = Math.max(
        maxAddonLicense,
        assignedBizPlusLicenseQuantity,
        totalLicenseWithoutFreeTrial,
        ZOOM_MEETING_PRO_MIN_LICENSE,
      );

      const planList = boughtBizPlusPlan.map((p) => {
        const extraKeys = {};
        if (ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(p.billing_cycle)) {
          Object.assign(extraKeys, { oldPlanType: p.plan_type });
        }
        return {
          oldPlanCode: p.plan_code,
          quantity: p.cartInfo.selected_number,
          ...extraKeys,
        };
      });
      const oldHotCache = this.migratePlanState.hotCache?.[nextEditPlanCategory];
      // remove biz+ plans
      this.travelsalRemovePlans([...selectedBizPlusPlan, selectedPbxBasePlan].map((p) => p.plan_code));
      // add biz plan to cart, keep same cycle with biz plus
      const billingCycle = selectedBizPlusPlan[0].billing_cycle;
      const bizPlan = this.planMapFlat.find(
        (p) =>
          p.billing_cycle === billingCycle &&
          p.type === planTypes.ZOOM_MEETING &&
          p.category === BASE_PLAN_SUB_TYPES.BIZ,
      );
      this.traversalUpdateSelectedPlans(oldHotCache?.length
          ? oldHotCache.map((p) => ({ plan_code: bizPlan.plan_code, cartInfo: p.cartInfo }))
          : [{ plan_code: bizPlan.plan_code, cartInfo: { selected_number: quantity }}]);
      // refresh plan card
      this.setMigratePlanState({
        planList,
      });
    },
    async biz2bundle({ nextEditPlanCategory }) {
      const boughtMeetingPlanLicense = plansof(this.boughtPlans).type(planTypes.ZOOM_MEETING).get(0)?.cartInfo?.selected_number ?? 0;
      const { selectedBizPlan, boughtBizPlan } = this.plansofBizBundle;
      const bizPlan = selectedBizPlan.length ? selectedBizPlan : boughtBizPlan;
      const quantity = Math.max(bizPlan?.[0]?.cartInfo?.selected_number, boughtMeetingPlanLicense, 10);
      const planList = bizPlan.map((p) => {
        return {
          oldPlanCode: p.plan_code,
          quantity: p.cartInfo.selected_number,
        };
      });
      const oldHotCache = this.migratePlanState.hotCache?.[nextEditPlanCategory];
      // remove biz plan
      this.travelsalRemovePlans(bizPlan.map(p => p.plan_code));
      // load cache
      if (oldHotCache?.length) {
        this.traversalUpdateSelectedPlans(oldHotCache.map(p => ({
          plan_code: p.plan_code,
          cartInfo: {selected_number: p.type === planTypes.ZOOM_ONE_BUNDLE ? quantity : p.cartInfo.selected_number},
        })));
      } else {
        const boughtMeetingPlan = plansof(this.boughtPlans).type(planTypes.ZOOM_MEETING).get(0);
        let billingCycle = boughtMeetingPlan.billing_cycle || BILLING_CYCLE.ANNUAL;
        const { pbxBasePlan, basePlan } = this.getBundlePbxPlans({billingCycle, codesMap: BIZ_PLUS_PLAN_CODES_ONLINE_SUPPORTED, planType: planTypes.ZOOM_ONE_BUNDLE});
        this.traversalUpdateSelectedPlans([
          { plan_code: basePlan.plan_code, cartInfo: { selected_number: quantity }},
          { plan_code: pbxBasePlan.plan_code, cartInfo: { selected_number: 1 }}
        ]);
      }
      // refresh plan card
      this.setMigratePlanState({
        planList,
      });
    },
    async esc2escplus({ nextEditPlanCategory }) {
      const selectedPlan = plansof(this.getSelectedPlans).type(planTypes.ZOOM_MEETING).category(ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP).get()
      const boughtPlan = plansof(this.boughtPlans).type(planTypes.ZOOM_MEETING).category(ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP).get()
      const escPlan = selectedPlan.length ? selectedPlan : boughtPlan;
      const planList = escPlan.map((p) => {
        return {
          oldPlanCode: p.plan_code,
          quantity: p.cartInfo.selected_number,
        };
      });
      const quantity = Math.max(escPlan?.[0]?.cartInfo?.selected_number || 0, ZOOM_MEETING_EDU_PLUS_MIN_LICENSE);

      this.travelsalRemovePlans(escPlan.map(p => p.plan_code));

      const oldHotCache = this.migratePlanState.hotCache?.[nextEditPlanCategory];
      if (oldHotCache?.length) {
        this.traversalUpdateSelectedPlans(oldHotCache.map(p => ({
          plan_code: p.plan_code,
          cartInfo: { selected_number: p.type === planTypes.ZONE_EDU_PLUS ? quantity : p.cartInfo.selected_number},
        })));
      } else {
        const billingCycle = boughtPlan?.[0]?.billing_cycle || BILLING_CYCLE.ANNUAL;
        const { pbxBasePlan, basePlan } = this.getBundlePbxPlans({ billingCycle, codesMap: EDU_SCH_CMP_PLUS_PLAN_CODES_SUPPORTED, planType: planTypes.ZONE_EDU_PLUS});
        this.traversalUpdateSelectedPlans([
          { plan_code: basePlan.plan_code, cartInfo: { selected_number: quantity }},
          { plan_code: pbxBasePlan.plan_code, cartInfo: { selected_number: 1 }}
        ]);
      }

      // refresh plan card
      this.setMigratePlanState({
        planList,
      });
    },
    async escplus2esc({ nextEditPlanCategory }) {
      const selectedPlan = plansof(this.getSelectedPlans).type(planTypes.ZONE_EDU_PLUS).get()
      const boughPlusPlan = plansof(this.boughtPlans).type(planTypes.ZONE_EDU_PLUS).get()

      const quantity = Math.max(
        getMinimumSubjectLicense(),
        getAssignedLicenseQuantity(boughPlusPlan, this.assignInfo),
        getSelfTotalLicenseAmount() - this.subscriptions.filter(p => p.isFreeTrial).map(p => p?.quantity ?? 0).reduce((p, v) => p + v, 0),
        ZOOM_MEETING_EDU_SCH_CMP_MIN_LICENSE,
      );

      const planList = selectedPlan.map((p) => ({
        oldPlanCode: p.plan_code,
        quantity: p.cartInfo.selected_number,
      }))
      const billingCycle = selectedPlan[0].billing_cycle;

      this.travelsalRemovePlans([...selectedPlan, get(computedPbxPlans(this.getSelectedPlans), '0', {})].map((p) => p.plan_code));

      const nextPlan = this.planMapFlat.find(
        (p) =>
          p.billing_cycle === billingCycle &&
          p.type === planTypes.ZOOM_MEETING &&
          p.category === ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP
      );
      const oldHotCache = this.migratePlanState.hotCache?.[nextEditPlanCategory];

      this.traversalUpdateSelectedPlans(oldHotCache?.length
          ? oldHotCache.map((p) => ({ plan_code: nextPlan.plan_code, cartInfo: p.cartInfo }))
          : [{ plan_code: nextPlan.plan_code, cartInfo: { selected_number: quantity }}]);

      // refresh plan card
      this.setMigratePlanState({
        planList,
      });
    },
    async switchMeetingPlanCategory({ category, targetLicenses = false }) {
      const currentBasePlan = get(this.getCurrentBasePlanInfo, 'plans.0', null);
      const targetPlans = this.planMapFlat.filter((item) => (item.type === planTypes.ZOOM_MEETING) & (item.category === category));
      // if isPriceIncreaseConsideredScense is true, item.code will equal to priceChangeMappingPlanCode
      const boughtTargetPlans = this.boughtPlans.find((item) => [currentBasePlan?.priceChangeMappingPlanCode, currentBasePlan?.plan_code].includes(item.plan_code));
      const { max, min } = get(targetPlans, '0', { max: 1, min: 99 });
      let billingCycle = BILLING_CYCLE.ANNUAL;
      let oldPlanCode = get(currentBasePlan, 'plan_code', '');
      let oldPlanCategory = get(currentBasePlan, 'category', '');
      let oldPlanHost = get(currentBasePlan, 'cartInfo.selected_number', '');
      let defaultLicenses = Math.min(max, oldPlanHost);
      category && (hostCache[oldPlanCategory] = oldPlanHost);
      if (oldPlanCode) {
        const { billing_cycle, cartInfo } = currentBasePlan;
        billingCycle = billing_cycle;
        if (this.$context.is.edit) {
          defaultLicenses = Math.max(min, boughtTargetPlans?.cartInfo?.selected_number ?? min, cartInfo?.selected_number);
        } else if (cartInfo.selected_number < min) {
          // If pro switch to biz default license is min of biz.
          defaultLicenses = min;
        } else if (cartInfo.selected_number > max) {
          // If biz switch to pro default license is max of pro.
          defaultLicenses = max;
        }

        if (isAutoAddable() && targetLicenses) {
          // If is buying we saas
          defaultLicenses = targetLicenses;
        }
      }
      const nextMeetingPlan = targetPlans.find(item => item.billing_cycle === billingCycle) || targetPlans[0];

      // keep original logic
      if(!targetLicenses && hostCache[category]) {
        // current will cover new subscription case
        const appliedFlowType = this.$context.is.buyNow || this.$context.is.basic2pro;

        if (appliedFlowType) {
          // If target is specified, do not use the cache.
          const ineligibleDefaultLicenseWillUseHostCache = defaultLicenses >= max || defaultLicenses <= min;
          ineligibleDefaultLicenseWillUseHostCache && (defaultLicenses = hostCache[nextMeetingPlan.category]);
        } else {
          defaultLicenses = hostCache[nextMeetingPlan.category];
        }
      }

      const exceedBaseLicensePlans = this.getSelectedPlans.filter(item => (
        (item.billing_cycle !== BILLING_CYCLE.ONE_TIME || item?.considerLicenseLimit) &&
        item.cartInfo.selected_number > defaultLicenses &&
        item.type !== planTypes.ZOOM_MEETING &&
        this.limitLicenseWithBaseZoneTypes.includes(item.type)
      ));
      if (
        exceedBaseLicensePlans.length > 0 &&
        // auto addable and all add-on plans support auto addable
        // do not show confirm dialog
        !(
          isAutoAddable() && exceedBaseLicensePlans.every(({ type }) => autoAddTypes.includes(type))
        )
      ) {
        const planGroupByType = groupBy(exceedBaseLicensePlans, 'type')
        const typeNames = Object.keys(planGroupByType).map(type => {
          const typeNameKey = get(planGroupByType[type], '0.typeNameKey', '');
          return this.$t(typeNameKey);
        });

        // MIX_BUY
        if (!this.$context.is.mixBuy) {
          await this.$confirm(
            this.$t('billing.zone.host_need_adjust.content', [typeNames.join(','), max]),
            this.$t('billing.zone.host_need_adjust.title', [typeNames.join(',')]),
            {
              confirmButtonText: this.$t('billing.common.confirm'),
              cancelButtonText: this.$t('billing.common.cancel'),
            }
          );
        }
        this.traversalUpdateSelectedPlans(exceedBaseLicensePlans.map(item => ({
          plan_code: item.plan_code,
          cartInfo: {
            ...item.cartInfo,
            selected_number: defaultLicenses,
          },
        })));
      }

      const cartInfo = { selected_number: defaultLicenses };
      if (category === BASE_PLAN_SUB_TYPES.BIZ || category === BASE_PLAN_SUB_TYPES.BIZ_INR) {
        if (plansof(this.getSelectedPlans).type(planTypes.ZOOM_SCHEDULER).get(0)?.isOnlineFreeTrial) {
          this.removePlanByKey(planTypes[planTypes.ZOOM_SCHEDULER])
          this.$message({
            message: this.$t('billing.scheduler.remove_in_biz_message'),
            iconClass: "zm-icon-info",
            showClose: true,
            customClass: 'opc-message__info'
          })
        }
      }

      await this.switchCategoryAction([oldPlanCode, {...nextMeetingPlan, cartInfo }]);
      this.setSelectedPlanLicense({currentLicense:this.defaultLicenses,baseLicense:defaultLicenses})

      this.handleSure();
    },
    jumpToOldFlow({ btn }) {
      const url = updateHrefWithQueryParams(btn.link, [
        generateCartIdWithQueryKey,
        PARTNER_REFER_KEY_MAP.jointsaleCodeKey,
        PARTNER_REFER_KEY_MAP.referralCodeKey,
        'referrer',
        'source',
        URL_PAGE_TYPE_KEY
      ], {
        ...getPersistCouponQueryInfo()
      });

      location.replace(url);
    },
    async pro2prop({ nextEditPlanCategory }) {
      const selectedMeetingPlan = this.getSelectedPlans.find((p) => p.type === planTypes.ZOOM_MEETING);
      const boughtProPlan = getMeetingPlanByCategory(this.boughtPlans, BASE_PLAN_SUB_TYPES.PRO);
      const quantity = boughtProPlan.cartInfo.selected_number >= ZOOM_ONE_PRO_PLUS_MAX_LICENSE ?
        boughtProPlan.cartInfo.selected_number : Math.min(ZOOM_ONE_PRO_PLUS_MAX_LICENSE, selectedMeetingPlan.cartInfo.selected_number);
      const planList = this.getSelectedPlans.map((p) => {
        return { oldPlanCode: p.plan_code, quantity: p.cartInfo.selected_number, };
      });
      const oldHotCache = this.migratePlanState.hotCache?.[nextEditPlanCategory];
      // remove pro plus plan
      this.travelsalRemovePlans([selectedMeetingPlan.plan_code]);
      // load cache
      if (oldHotCache?.length) {
        this.traversalUpdateSelectedPlans(oldHotCache);
      } else {
        let billingCycle = selectedMeetingPlan.billing_cycle || BILLING_CYCLE.ANNUAL;
        const { pbxBasePlan, basePlan } = this.getBundlePbxPlans({billingCycle, codesMap: PRO_PLUS_PLAN_CODES_SUPPORTED, planType: planTypes.ZONE_PRO_PLUS});
        // pro plus
        this.traversalUpdateSelectedPlans([
          { plan_code: basePlan.plan_code, cartInfo: { selected_number: quantity }, },
          { plan_code: pbxBasePlan.plan_code, cartInfo: { selected_number: 1 }, },
        ]);
      }
      // refresh plan card
      this.setMigratePlanState({
        planList,
      });
    },
    async prop2bundle({ nextEditPlanCategory }) {
      const proPlus = this.getSelectedPlans.find((p) => p.type === planTypes.ZONE_PRO_PLUS);
      const boughtProp = this.boughtPlans.find((p) => p.type === planTypes.ZONE_PRO_PLUS);
      const quantity = Math.max(
        boughtProp?.cartInfo?.selected_number,
        proPlus?.cartInfo?.selected_number,
        ZOOM_MEETING_PRO_MIN_LICENSE,
      );
      const planList = this.getSelectedPlans.map((p) => {
        return { oldPlanCode: p.plan_code, quantity: p.cartInfo.selected_number, };
      });
      const oldHotCache = this.migratePlanState.hotCache?.[nextEditPlanCategory];
      // remove pro plus plan
      this.travelsalRemovePlans([this.currentEditPlan.plan_code]);
      // load cache
      if (oldHotCache?.length) {
        this.traversalUpdateSelectedPlans(oldHotCache);
      } else {
        let billingCycle = this.currentEditPlan.billing_cycle || BILLING_CYCLE.ANNUAL;
        // add biz plus plans to cart
        const bizPlusPlan = this.planMapFlat.find(
          (x) =>
            x.billing_cycle === billingCycle &&
            x.type === planTypes.ZOOM_ONE_BUNDLE &&
            BIZ_PLUS_PLAN_CODES_ONLINE_SUPPORTED.includes(x.plan_code),
        );
        this.traversalUpdateSelectedPlans([{ plan_code: bizPlusPlan.plan_code, cartInfo: { selected_number: quantity }}]);
      }
      // refresh plan card
      this.setMigratePlanState({
        planList,
      });
    },
    async pro2bundle({ nextEditPlanCategory }) {
      const selectedMeetingPlan = this.getSelectedPlans.find((p) => p.type === planTypes.ZOOM_MEETING);
      const boughtProPlan = getMeetingPlanByCategory(this.boughtPlans, BASE_PLAN_SUB_TYPES.PRO);
      const quantity = Math.max(
        boughtProPlan.cartInfo.selected_number,
        selectedMeetingPlan.cartInfo.selected_number,
        10,
      );
      const planList = this.getSelectedPlans.map((p) => {
        return {
          oldPlanCode: p.plan_code,
          quantity: p.cartInfo.selected_number,
        };
      });
      const oldHotCache = this.migratePlanState.hotCache?.[nextEditPlanCategory];
      // remove pro plan
      this.travelsalRemovePlans([selectedMeetingPlan.plan_code]);
      // load cache
      if (oldHotCache?.length) {
        this.traversalUpdateSelectedPlans(oldHotCache);
      } else {
        let billingCycle = selectedMeetingPlan.billing_cycle || BILLING_CYCLE.ANNUAL;
        const { pbxBasePlan, basePlan } = this.getBundlePbxPlans({billingCycle, codesMap: BIZ_PLUS_PLAN_CODES_ONLINE_SUPPORTED, planType: planTypes.ZOOM_ONE_BUNDLE});
        this.traversalUpdateSelectedPlans([
          { plan_code: basePlan.plan_code, cartInfo: { selected_number: quantity }, },
          { plan_code: pbxBasePlan.plan_code, cartInfo: { selected_number: 1 }, }
        ]);
      }
      // refresh plan card
      this.setMigratePlanState({
        planList,
      });
    },
    getBundlePbxPlans({billingCycle, planType, codesMap }) {
      const boughtPbxBasePlans = computedPbxBasePlans(this.boughtPlans);
      const boughtPbxPlans = computedPbxNonBasePlans(this.boughtPlans);
      const boughtPbxBasePlan = boughtPbxBasePlans?.[0];

      if (boughtPbxBasePlan) {
        billingCycle = getPbxCurrentBillingCycle(boughtPbxBasePlan, boughtPbxPlans?.[0]);
      }

      const basePlan = this.planMapFlat.find((x) => x.billing_cycle === billingCycle && x.type === planType && codesMap.includes(x.plan_code));

      let pbxBasePlan = boughtPbxBasePlans?.[0] || computedPbxBasePlans(this.planMapFlat).find((p) => p.category === PBX_CATEGORYS.ZVP);

      return {
        pbxBasePlan,
        basePlan
      }
    },
    traversalUpdateSelectedPlans(plans) {
      plans.forEach(({ plan_code, cartInfo }) => {
        this.updateSelectPlan({
          plan_code,
          cartInfo,
        });
      });
    },
    travelsalRemovePlans(plans) {
      plans.forEach((code) => {
        this.removePlan(code);
      });
    },
    getFnByMigrateTypes() {
      return {
        [MIGRATE_FLOW_TYPES.pro2bundle]({
          col,
          currentEditPlanCategory,
          originEditPlanCategory,
          nextEditPlanCategory,
        }) {
          return this.pro2bundle({
            col,
            currentEditPlanCategory,
            originEditPlanCategory,
            nextEditPlanCategory,
          });
        },
        [MIGRATE_FLOW_TYPES.pro2biz]({ col }) {
          return this.switchMeetingPlanCategory(col);
        },
        [MIGRATE_FLOW_TYPES.bizBack2pro]({ col }) {
          return this.switchMeetingPlanCategory(col);
        },
        [MIGRATE_FLOW_TYPES.bundleBack2pro]({ currentEditPlanCategory, nextEditPlanCategory }) {
          return this.loadOriginalHotCache({ currentEditPlanCategory, nextEditPlanCategory });
        },
        [MIGRATE_FLOW_TYPES.biz2bundle]({ nextEditPlanCategory }) {
          return this.biz2bundle({ nextEditPlanCategory });
        },
        [MIGRATE_FLOW_TYPES.biz2pro]({ col }) {
          return this.switchMeetingPlanCategory(col);
        },
        [MIGRATE_FLOW_TYPES.bundleBack2biz]({ currentEditPlanCategory, nextEditPlanCategory }) {
          return this.loadOriginalHotCache({ currentEditPlanCategory, nextEditPlanCategory });
        },
        [MIGRATE_FLOW_TYPES.proBack2biz]({ col }) {
          return this.switchMeetingPlanCategory(col);
        },
        [MIGRATE_FLOW_TYPES.bundle2biz]({ nextEditPlanCategory }) {
          return this.bundle2biz({ nextEditPlanCategory });
        },
        [MIGRATE_FLOW_TYPES.bizBack2bundle]({ currentEditPlanCategory, nextEditPlanCategory }) {
          return this.loadOriginalHotCache({ currentEditPlanCategory, nextEditPlanCategory });
        },
        [MIGRATE_FLOW_TYPES.bundle2pro]() {
          return false;
        },
        [MIGRATE_FLOW_TYPES.pro2prop]({ nextEditPlanCategory }) {
          return this.pro2prop({ nextEditPlanCategory });
        },
        [MIGRATE_FLOW_TYPES.prop2bundle]({ nextEditPlanCategory }) {
          return this.prop2bundle({ nextEditPlanCategory });
        },
        [MIGRATE_FLOW_TYPES.bundleBack2proplus]({ currentEditPlanCategory, nextEditPlanCategory }) {
          return this.loadOriginalHotCache({ currentEditPlanCategory, nextEditPlanCategory });
        },
        [MIGRATE_FLOW_TYPES.proplusBack2pro]({ nextEditPlanCategory, currentEditPlanCategory }) {
          return this.loadOriginalHotCache({ currentEditPlanCategory, nextEditPlanCategory });
        },
        [MIGRATE_FLOW_TYPES.eduschcmp2eduschcmpplus]({ nextEditPlanCategory }) {
          return this.esc2escplus({ nextEditPlanCategory });
        },
        [MIGRATE_FLOW_TYPES.eduschcmpplus2eduschcmp]({ nextEditPlanCategory }) {
          return this.escplus2esc({ nextEditPlanCategory });
        },
        [MIGRATE_FLOW_TYPES.revert2eduschcmpplus]({ currentEditPlanCategory, nextEditPlanCategory }) {
          return this.loadOriginalHotCache({ currentEditPlanCategory, nextEditPlanCategory });
        },
        [MIGRATE_FLOW_TYPES.revert2eduschcmp]({ currentEditPlanCategory, nextEditPlanCategory }) {
          return this.loadOriginalHotCache({ currentEditPlanCategory, nextEditPlanCategory });
        },
        [MIGRATE_FLOW_TYPES.biz2proplus]({ currentEditPlanCategory, nextEditPlanCategory }) {
          return this.__switchMeetingPlan({ currentEditPlanCategory, nextEditPlanCategory });
        },
        [MIGRATE_FLOW_TYPES.r_biz2proplus]({ currentEditPlanCategory, nextEditPlanCategory }) {
          return this.loadOriginalHotCache({ currentEditPlanCategory, nextEditPlanCategory });
        },
        [MIGRATE_FLOW_TYPES.bizplus2proplus]({ currentEditPlanCategory, nextEditPlanCategory }) {
          return this.__switchMeetingPlan({ currentEditPlanCategory, nextEditPlanCategory });
        },
        [MIGRATE_FLOW_TYPES.r_bizplus2proplus]({ currentEditPlanCategory, nextEditPlanCategory }) {
          return this.loadOriginalHotCache({ currentEditPlanCategory, nextEditPlanCategory });
        },
      };
    },
    __getPlanType(category) {
      switch(category) {
        case BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS:
          return planTypes.ZOOM_ONE_BUNDLE;
        case BASE_PLAN_SUB_TYPES.ZOOM_ONE_PRO_PLUS:
          return planTypes.ZONE_PRO_PLUS;
        case BASE_PLAN_SUB_TYPES.ZONE_EDU_PLUS:
          return planTypes.ZONE_EDU_PLUS
        case BASE_PLAN_SUB_TYPES.PRO:
        case BASE_PLAN_SUB_TYPES.BIZ:
        case BASE_PLAN_SUB_TYPES.ZONE_EDU_SCH_CMP:
        case BASE_PLAN_SUB_TYPES.EDUCATION:
        default:
          return planTypes.ZOOM_MEETING;
      }
    },
    __getMaxAndMin(category) {
      const type = this.__getPlanType(category);
      let targetPlan = null;
      if (type === planTypes.ZOOM_MEETING) {
        targetPlan = plansof(this.planMapFlat).type(type).category(category).plans[0];
      } else {
        targetPlan = plansof(this.planMapFlat).type(type).plans[0];
      }
      return {
        max: targetPlan ? targetPlan.max : DEFAULT_MAX_HOST,
        min: targetPlan ? targetPlan.min : DEFAULT_MIN_HOST,
      };
    },
    __getDefaultLicense(category, minAndMax) {
      const oldLicense = this.getCurrentBasePlanInfo.plans.reduce((preVal, item) => item.cartInfo.selected_number + preVal, 0);
      const { min, max } = minAndMax || this.__getMaxAndMin(category);

      if (min > oldLicense) return min;
      if (max < oldLicense) return max;
      return oldLicense;
    },
    __getDefaultCycle(category) {
      const type = this.__getPlanType(category);
      if (type === planTypes.ZOOM_MEETING) {
        // use current billing cycle
        return this.currentBaseCycle || BILLING_CYCLE.ANNUAL;
      }
      return this.currentPbxCycle || this.currentBaseCycle || BILLING_CYCLE.ANNUAL;
    },
    /**
     * @typedef ActionPayload
     * @property {String} plan_code
     * @property {Object} cartInfo
     *
     * @typedef {Object} Action
     * @property {StoreActionTypes} action
     * @property {ActionPayload} payload
     *
     * @param  {...Action} actions
     */
    __pushStoreActions(...actions) {
      this.storeActionQueue.push(...actions);
    },
    __execStoreActions() {
      // remove plans
      this.storeActionQueue
      .filter(item => item.action === StoreActionTypes.REMOVE)
      .forEach(({payload}) => {
        if(payload?.plan_code) {
          this.__execRemoveAction(payload.plan_code)
        }
      });
      // update plans
      this.storeActionQueue
      .filter(item => item.action === StoreActionTypes.UPDATE)
      .forEach(({ payload }) => {
        if(payload?.plan_code) {
          this.__execUpdateAction(payload.plan_code, payload.cartInfo)
        }
      });
    },
    __execRemoveAction(plan_code) {
      this.removePlan(plan_code);
    },
    __execUpdateAction(plan_code, cartInfo) {
      this.updateSelectPlan({
        plan_code,
        cartInfo,
      });
    },
    __switchMeetingPlan({ nextEditPlanCategory }) {
      const oldHotCache = this.migratePlanState.hotCache?.[nextEditPlanCategory];
      // remove pro plus plan
      this.__pushStoreActions(
        ...this.getSelectedPlans.map(
          payload => ({
            action: StoreActionTypes.REMOVE,
            payload,
          })
        )
      );

      // load cache
      if (oldHotCache?.length) {
        this.__pushStoreActions(
          ...oldHotCache.map(payload => ({
            action: StoreActionTypes.UPDATE,
            payload,
          }))
        );
      } else {
        let quantity = 0;
        if (nextEditPlanCategory === BASE_PLAN_SUB_TYPES.ZOOM_ONE_PRO_PLUS) {
          quantity = this.__getDefaultLicense(nextEditPlanCategory, { min: 1, max: 99 });
        } else {
          quantity = this.__getDefaultLicense(nextEditPlanCategory);
        }
        const billingCycle = this.__getDefaultCycle(nextEditPlanCategory);
        const targetType = this.__getPlanType(nextEditPlanCategory);
        let targetPlanOf = plansof(this.planMapFlat).type(targetType);

        if (targetType === planTypes.ZOOM_MEETING) {
          targetPlanOf = targetPlanOf.category(nextEditPlanCategory);
        }

        if (targetPlanOf.cycle(billingCycle).plans.length > 0) {
          targetPlanOf = targetPlanOf.cycle(billingCycle);
        }

        const targetPlan = targetPlanOf.plans[0];
        // pro plus
        targetPlan && this.__pushStoreActions({
          action: StoreActionTypes.UPDATE,
          payload: { plan_code: targetPlan.plan_code, cartInfo: { selected_number: quantity } },
        })

        if (targetPlan && targetPlan.defaultPbxBase) {
          const defaultPbxPlan = this.pbxBasePlan || plansof(this.planMapFlat).type(planTypes.ZOOM_PHONE).category(targetPlan.defaultPbxBase).plans[0];
          defaultPbxPlan && this.__pushStoreActions({
            action: StoreActionTypes.UPDATE,
            payload: { plan_code: defaultPbxPlan.plan_code, cartInfo: { selected_number: 1 } },
          })
        }
      }
      // refresh plan card
      this.setMigratePlanState({
        planList: this.getSelectedPlans.map((p) => {
          return { oldPlanCode: p.plan_code, quantity: p.cartInfo.selected_number, };
        }),
      });
      this.__execStoreActions();
    },
    getGATrackingName({originEditPlanCategory, nextEditPlanCategory}) {
      let trackingName = '', productName = '';
      switch (originEditPlanCategory) {
        case ZOOM_MEETING_SUB_TYPES.PRO:
          trackingName = trackingPlanTypes.ZOOM_MEETING + ' pro';
          break;
        case ZOOM_MEETING_SUB_TYPES.BIZ:
          trackingName = trackingPlanTypes.ZOOM_MEETING + ' biz';
          break;
        case ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_PRO_PLUS:
          trackingName = trackingPlanTypes.ZONE_PRO_PLUS;
          break;
        case ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_BIZ_PLUS:
          trackingName = trackingPlanTypes.ZONE_BIZ_PLUS;
          break;
      }
      switch (nextEditPlanCategory) {
        case ZOOM_MEETING_SUB_TYPES.PRO:
          productName = trackingPlanTypes.ZOOM_MEETING + ' pro';
          break;
        case ZOOM_MEETING_SUB_TYPES.BIZ:
          productName = trackingPlanTypes.ZOOM_MEETING + ' biz';
          break;
        case ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_PRO_PLUS:
          productName = trackingPlanTypes.ZONE_PRO_PLUS;
          break;
        case ZOOM_MEETING_SUB_TYPES.ZOOM_ONE_BIZ_PLUS:
          productName = trackingPlanTypes.ZONE_BIZ_PLUS;
          break;
      }
      return { trackingName: this.$t(trackingName), productName: this.$t(productName) };
    },
  },
};
